import { render } from "./Competencies.vue?vue&type=template&id=423dcdb9&ts=true"
import script from "./Competencies.vue?vue&type=script&lang=ts"
export * from "./Competencies.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__